import { toDate } from "../utils";

import { VerificationOfResidency } from "./interfaces";

export const mapVoR = (
  verifications?: Record<string, any>[],
  enabled?: boolean
): VerificationOfResidency | undefined => {
  if (!Array.isArray(verifications)) return undefined;
  const vor = verifications?.find(
    (verification) =>
      verification?.verificationType === "VOR" ||
      verification?.verification_type === "VOR" ||
      verification?.type === "VOR"
  );
  const details = vor?.details;
  if (!details) return undefined;
  const lowestScore = details.survey?.surveyQuestions
    ?.map((e) => Number(e.answer ?? undefined))
    .filter((e) => !!e || e === 0)
    .reduce((min, next) => (min === null || next < min ? next : min), null);
  return {
    submission:
      toDate(vor?.verificationDate ?? vor?.verification_date) ??
      toDate(vor?.completedAt ?? vor?.completed_at) ??
      undefined,
    landlordEmail: details.landlord?.email ?? details.landlord?.email_address,
    landlordName: details.landlord?.fullName ?? details.landlord?.full_name,
    landlordPhone: details.landlord?.phoneNumber ?? details.landlord?.phone_number,
    score: details.survey?.score,
    outOf: details.survey?.outOf ?? details.survey?.out_of,
    status: details.survey?.status,
    lowestScore: lowestScore ?? undefined,
    enabled,
  };
};
